export default __webpack_public_path__ + "static/media/unit2.67acaeb9.jpg";